import React, { FunctionComponent } from 'react';
import { cn, snakeToSentenceCase } from '@companion-professional/webutils';
import { FileVideo2 } from 'lucide-react';
import { CheckupRequestInfo } from '@companion-professional/dctypes';

interface ItemSelectorProps {
  checkup: CheckupRequestInfo;
  currentItemId: string | null;
  setCurrentItemId: (itemId: string | null) => void;
}

// ItemSelector is a component that displays a list of items in a checkup request and allows the user to select one.
// The selected item is highlighted, and clicking on an item will set it as the current item using the setCurrentItemId
// function.
export const ItemSelector: FunctionComponent<ItemSelectorProps> = ({ checkup, currentItemId, setCurrentItemId }) => {
  return (
    <div className="min-w-32 border-l-2 border-primary">
      {checkup?.requests.map((item, i) =>
        item.upload_count > 0 ? (
          <div
            key={`request-item-${checkup.id}-${item.item_id}`}
            className={cn('flex h-12 flex-row items-center justify-between px-4', {
              'cursor-pointer text-muted-foreground hover:bg-accent': currentItemId !== item.item_id,
              'bg-primary text-on-primary': currentItemId === item.item_id
            })}
            onClick={() => setCurrentItemId(item.item_id)}
          >
            <FileVideo2 className="w-8" />
            <div className="flex w-full flex-col text-sm">
              <span className="ml-2">
                {snakeToSentenceCase(item.item_type)} #{i + 1}
              </span>
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};
